module.exports = __webpack_public_path__ + "static/media/Partner12.305b951e.webp";